import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	loadingSpinnerContainer: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
});
